import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tab-bar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "tab-pane-element"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "elements-meta mb4" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 1,
  class: "ib vm comment-type"
}
const _hoisted_8 = {
  key: 2,
  class: "ib vm username-disp"
}
const _hoisted_9 = {
  key: 0,
  class: "ts"
}
const _hoisted_10 = {
  key: 0,
  class: "mb2"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "elements-meta mb4" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = {
  key: 0,
  class: "ib vm title-disp"
}
const _hoisted_16 = {
  key: 0,
  class: "ts"
}
const _hoisted_17 = {
  key: 0,
  class: "mb2"
}
const _hoisted_18 = ["innerHTML"]

import {
  computed,
  onMounted,
  reactive,
  watch,
} from 'vue';
import type { MapElemInfo, Tab, TabResources } from 'src/models';
import type { GIComment, GIResourceWithID } from 'src/models/geoItem';
import type { RecentCommentElement } from 'src/models/comment';
import { fuzzyTimeDisp } from 'src/lib/dateHelper';

interface TabLable {
  dataName: string;
  label: string;
}

interface TabData {
  dataName: string;
  resources: TabResources;
}

// comment以外のタブ要素でテンプレートが参照する表示用フィールド。
// 実体はレイヤーごとに異なるGIリソースで、フィールドを持たない場合はv-ifで非表示になる。
interface TabPaneElement {
  id: number | string;
  ts?: Date;
  titleDisp?: string;
  kpDisp?: string;
  contentDisp?: string;
}

interface TabPaneState {
  activeTab: string;
}

interface Props {
  tabs: Tab[];
  defaultActiveTab: string;
  tabContainerMinHeight: string;
  tabContainerMaxHeight: string;
  tabContentMaxHeight: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TabPaneComponent',
  props: {
    tabs: {},
    defaultActiveTab: {},
    tabContainerMinHeight: {},
    tabContainerMaxHeight: {},
    tabContentMaxHeight: {}
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<TabPaneState>({
  activeTab: '',
});

const tabLabels = computed<TabLable[]>(() => {
  return props.tabs.map(e => {
    return { dataName: e.dataName, label: e.label };
  });
});
const tabData = computed<TabData[]>(() => {
  return props.tabs.map(e => {
    return { dataName: e.dataName, resources: e.resources };
  });
});

onMounted(() => {
  state.activeTab = props.defaultActiveTab;
});

// watch:
watch(() => props.tabs, () => {
  // tabsの中にactiveTabが含まれない時、選択を初期化する
  if (!props.tabs.map(e => e.dataName).includes(state.activeTab)) {
    state.activeTab = props.defaultActiveTab;
  }
});

// methods
const onTabClick = (dataName: string) => {
  state.activeTab = dataName;
};
// commentタブの要素はuseRecentComment側でGIComment+kpDispとして構築されるため、その型へ絞り込む
const commentElements = (tab: TabData): RecentCommentElement[] => {
  return tab.resources.elements as RecentCommentElement[];
};
// comment以外のタブ要素は実体がレイヤーごとに異なるため、テンプレートで参照する表示用フィールドの型へ絞り込む
const tabPaneElements = (tab: TabData): TabPaneElement[] => {
  return tab.resources.elements as TabPaneElement[];
};
const onRecentCommentsClick = (comment: GIComment) => {
  const params: MapElemInfo<GIComment> = {
    data: comment,
    dataName: 'comment',
  };
  emit('click', params);
};
const onTabElementClick = (element: TabPaneElement, dataName: string) => {
  const params: MapElemInfo<GIResourceWithID> = {
    // タブ要素の実体はGIResourceWithID。表示用に絞り込んだ型から実体の型へ戻す
    data: element as GIResourceWithID,
    dataName,
  };
  emit('click', params);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tab-container mt8",
    style: _normalizeStyle({
    'min-height': props.tabContainerMinHeight,
    'max-height': props.tabContainerMaxHeight,
  })
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabLabels.value, (tabLabel) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["tab-item", {active: state.activeTab === tabLabel.dataName}]),
          key: tabLabel.dataName,
          onClick: ($event: any) => (onTabClick(tabLabel.dataName))
        }, _toDisplayString(tabLabel.label), 11, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "tab-content",
      style: _normalizeStyle({'max-height': props.tabContentMaxHeight})
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabData.value, (tabEntry) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab-pane", {active: state.activeTab === tabEntry.dataName}]),
          key: tabEntry.dataName
        }, [
          (!tabEntry.resources.ready)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "ta-center" }, [
                  _createElementVNode("i", { class: "fa-2x fas fa-spinner fa-spin" })
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (tabEntry.dataName === 'comment')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(commentElements(tabEntry), (e) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "tab-pane-element elements",
                        onClick: ($event: any) => (onRecentCommentsClick(e)),
                        key: e.id
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            (!!e.commentTypeColorCode)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["ib vm color-box", [`color-${e.commentTypeColorCode}`]])
                                }, null, 2))
                              : _createCommentVNode("", true),
                            (!!e.commentTypeDisp)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "【" + _toDisplayString(e.commentTypeDisp) + "】", 1))
                              : _createCommentVNode("", true),
                            (!!e.userDisplayName)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(e.userDisplayName), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!!e.ts)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(fuzzyTimeDisp)(e.ts, new Date())), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (!!e.kpDisp)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "場所: " + _toDisplayString(e.kpDisp), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: "elements-content",
                          innerHTML: e.contentDisp
                        }, null, 8, _hoisted_11)
                      ], 8, _hoisted_4))
                    }), 128))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(tabPaneElements(tabEntry), (e) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "tab-pane-element elements",
                        onClick: ($event: any) => (onTabElementClick(e, tabEntry.dataName)),
                        key: e.id
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            (!!e.titleDisp)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(e.titleDisp), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!!e.ts)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(fuzzyTimeDisp)(e.ts, new Date())), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (!!e.kpDisp)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, "場所: " + _toDisplayString(e.kpDisp), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: "elements-content",
                          innerHTML: e.contentDisp
                        }, null, 8, _hoisted_18)
                      ], 8, _hoisted_12))
                    }), 128))
              ], 64))
        ], 2))
      }), 128))
    ], 4)
  ], 4))
}
}

})